<table class="if-table">
  <thead>
    <tr>
      @for (column of columns(); track column) {
        <th [class.if-table-cell-sortable]="column.sortable" (click)="sort(column)">
          <div>
            <span>{{ column.headerText }}</span>
            @if (column.sortable) {
              <span>
                @if (column.sortDirection === 'asc') {
                  ↑
                }
                @if (column.sortDirection === 'desc') {
                  ↓
                }
                @if (!column.sortDirection) {
                  ↓↑
                }
              </span>
            }
          </div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    <!-- Groupable mode with expandable rows -->
    @if (groupable() && groups().length > 0) {
      @for (group of groups(); track group.id) {
        <!-- Group header row -->
        <tr class="group-header-row" [class.expanded]="isGroupExpanded(group.id)" (click)="toggleGroup(group.id)">
          <td [attr.colspan]="columns().length" class="group-header-cell">
            <ng-container *ngTemplateOutlet="getTemplate('groupHeader'); context: { $implicit: group, expanded: isGroupExpanded(group.id) }"></ng-container>
          </td>
        </tr>
        <!-- Group items (shown when expanded) -->
        @if (isGroupExpanded(group.id)) {
          @for (item of group.items; track item['id']) {
            <tr class="group-item-row">
              @for (col of columns(); track col) {
                @if (col.columnType === 'template') {
                  <td
                    [class.preview-col]="col.field === 'preview'"
                    [class.width-zero]="col.widthZero || col.field === 'actions'"
                    [class.truncate-200]="col.truncate === '200'"
                    [class.editable-cell]="col.editable"
                    [class.editing]="col.field && isEditing(item, col.field)"
                    (dblclick)="col.editable && col.field ? startEditing(item, col.field) : null">
                    @if (col.editable && col.field && isEditing(item, col.field)) {
                      <app-input
                        [(ngModel)]="editingValue"
                        (keydown)="onKeyDown($event, item)"
                        (blur)="saveEditing(item)"
                        class="inline-edit-input"
                        #editInput
                        (click)="$event.stopPropagation()" />
                    } @else {
                      <ng-container *ngTemplateOutlet="getTemplate(col.field!); context: { $implicit: item, isGroupItem: true }"></ng-container>
                    }
                  </td>
                } @else if (col.columnType === 'datetime' && col.field) {
                  <td [class.width-zero]="col.widthZero" [class.truncate-200]="col.truncate === '200'">
                    {{ $any(item[col.field]) | humandate }}
                  </td>
                } @else if (col.field) {
                  <td
                    [class.preview-col]="col.field === 'preview'"
                    [class.width-zero]="col.widthZero"
                    [class.truncate-200]="col.truncate === '200'"
                    [class.editable-cell]="col.editable"
                    [class.editing]="isEditing(item, col.field)">
                    @if (col.editable && isEditing(item, col.field)) {
                      <app-input
                        type="text"
                        [(ngModel)]="editingValue"
                        (keydown)="onKeyDown($event, item)"
                        (blur)="saveEditing(item)"
                        class="inline-edit-input"
                        #editInput
                        (click)="$event.stopPropagation()" />
                    } @else {
                      <span
                        [class.editable-text]="col.editable"
                        (dblclick)="col.editable ? startEditing(item, col.field) : null">
                        {{ item[col.field] }}
                      </span>
                    }
                  </td>
                }
              }
            </tr>
          }
          @if (group.items.length === 0) {
            <tr class="group-empty-row">
              <td [attr.colspan]="columns().length" class="group-empty-cell">
                <ng-container *ngTemplateOutlet="getTemplate('groupEmpty'); context: { $implicit: group }"></ng-container>
              </td>
            </tr>
          }
        }
      }
    }
    <!-- Regular data rows (non-groupable mode or standalone items) -->
    @if (!groupable() || (groupable() && data().length > 0)) {
      @for (item of data(); track item['id']) {
        <tr>
          @for (col of columns(); track col) {
            @if (col.columnType === 'template') {
              <td
                [class.preview-col]="col.field === 'preview'"
                [class.width-zero]="col.widthZero || col.field === 'actions'"
                [class.truncate-200]="col.truncate === '200'"
                [class.editable-cell]="col.editable"
                [class.editing]="col.field && isEditing(item, col.field)"
                (dblclick)="col.editable && col.field ? startEditing(item, col.field) : null">
                @if (col.editable && col.field && isEditing(item, col.field)) {
                  <app-input
                    [(ngModel)]="editingValue"
                    (keydown)="onKeyDown($event, item)"
                    (blur)="saveEditing(item)"
                    class="inline-edit-input"
                    #editInput
                    (click)="$event.stopPropagation()" />
                } @else {
                  <ng-container *ngTemplateOutlet="getTemplate(col.field!); context: { $implicit: item }"></ng-container>
                }
              </td>
            } @else if (col.columnType === 'datetime' && col.field) {
              <td [class.width-zero]="col.widthZero" [class.truncate-200]="col.truncate === '200'">
                {{ $any(item[col.field]) | humandate }}
              </td>
            } @else if (col.field) {
              <td
                [class.preview-col]="col.field === 'preview'"
                [class.width-zero]="col.widthZero"
                [class.truncate-200]="col.truncate === '200'"
                [class.editable-cell]="col.editable"
                [class.editing]="isEditing(item, col.field)">
                @if (col.editable && isEditing(item, col.field)) {
                  <app-input
                    type="text"
                    [(ngModel)]="editingValue"
                    (keydown)="onKeyDown($event, item)"
                    (blur)="saveEditing(item)"
                    class="inline-edit-input"
                    #editInput
                    (click)="$event.stopPropagation()" />
                } @else {
                  <span
                    [class.editable-text]="col.editable"
                    (dblclick)="col.editable ? startEditing(item, col.field) : null">
                    {{ item[col.field] }}
                  </span>
                }
              </td>
            }
          }
        </tr>
      }
    }
  </tbody>
</table>
